module.exports = __webpack_public_path__ + "img/app-store-badge.29be8850.svg";